import { render } from "./AddPlantProvider.vue?vue&type=template&id=c33b7982&scoped=true"
import script from "./AddPlantProvider.vue?vue&type=script&lang=js"
export * from "./AddPlantProvider.vue?vue&type=script&lang=js"

import "./AddPlantProvider.vue?vue&type=style&index=0&id=c33b7982&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33b7982"]])

export default __exports__